module.exports = __webpack_public_path__ + "static/media/im.6cf57263.svg";